import React from 'react';
import '/Users/jilin/projects/antd/rc-dialog/docs/demo/draggable.md?watch=parent';
import * as docs_demo_draggable_demo_draggable_deps_1 from 'bootstrap/dist/css/bootstrap.css';
import * as docs_demo_draggable_demo_draggable_deps_2 from 'react';
import * as docs_demo_draggable_demo_draggable_deps_3 from 'react-draggable';
import * as docs_demo_draggable_demo_draggable_deps_4 from 'rc-dialog';
import * as docs_demo_draggable_demo_draggable_deps_5 from '/Users/jilin/projects/antd/rc-dialog/assets/index.less';
export const demos = {
  'docs-demo-draggable-demo-draggable': {
    component: React.memo(React.lazy(() => import( /* webpackChunkName: "demos" */ '/Users/jilin/projects/antd/rc-dialog/docs/examples/draggable.tsx?techStack=react'))),
    asset: {
  "type": "BLOCK",
  "id": "docs-demo-draggable-demo-draggable",
  "refAtomIds": [],
  "dependencies": {
    "index.tsx": {
      "type": "FILE",
      "value": require('/Users/jilin/projects/antd/rc-dialog/docs/examples/draggable.tsx?dumi-raw').default
    },
    "bootstrap": {
      "type": "NPM",
      "value": "4.6.2"
    },
    "react": {
      "type": "NPM",
      "value": "18.3.1"
    },
    "react-draggable": {
      "type": "NPM",
      "value": "4.4.6"
    },
    "@rc-component/dialog": {
      "type": "NPM",
      "value": "1.0.1"
    },
    "../../assets/index.less": {
      "type": "FILE",
      "value": require('/Users/jilin/projects/antd/rc-dialog/assets/index.less?dumi-raw').default
    }
  },
  "entry": "index.tsx"
},
    context: {
  "../../assets/index.less": docs_demo_draggable_demo_draggable_deps_5,
  "bootstrap/dist/css/bootstrap.css": docs_demo_draggable_demo_draggable_deps_1,
  "react": docs_demo_draggable_demo_draggable_deps_2,
  "react-draggable": docs_demo_draggable_demo_draggable_deps_3,
  "rc-dialog": docs_demo_draggable_demo_draggable_deps_4,
  "/Users/jilin/projects/antd/rc-dialog/assets/index.less": docs_demo_draggable_demo_draggable_deps_5
},
    renderOpts: {
          
          compile: async (...args) => {
            return (await import('/Users/jilin/projects/antd/rc-dialog/node_modules/_dumi@2.4.17@dumi/dist/client/misc/reactDemoCompiler.js')).default(...args);
          },
        },
  },
};